import {Component, OnInit, Input, AfterViewInit, Output, EventEmitter} from '@angular/core';
import { CuentasService } from '../../../services/cuentas-service';
import { PricePipe, TnsPipe } from '../../../utils/pipes';
import set = Reflect.set;

@Component({
  selector: 'app-cliente-saldo-list',
  templateUrl: './cliente-saldo-list.component.html',
  styleUrls: ['./cliente-saldo-list.component.scss']
})
export class ClienteSaldoListComponent implements OnInit, AfterViewInit {

  @Input('isNewNegocio') isNewNegocio = true;

  public columns = ['producto', 'cosecha', 'saldo', 'comprometidas', 'oportunidades'];

  public rows  = [];

  public displayGrid = false;

  public displayLoadCircle = false;

  private noResultsMessage = '';

  @Output() viewInitialized = new EventEmitter<{}>();

  constructor(private cuentasService: CuentasService,
              private tnsPipe: TnsPipe,
              private pricePipe: PricePipe) { }

  ngOnInit() {
    if (!this.isNewNegocio) {
      this.displayGrid = true;
    }
    this.noResultsMessage = this.isNewNegocio ? 'Debe completar los campos "Cliente" y "Acopio"' : 'Por favor, seleccione un Acopio';
  }

  ngAfterViewInit() {
    this.viewInitialized.emit({});
  }

  getColumnName(col) {
    return col.charAt(0).toUpperCase() + col.slice(1);
  }

  getCellValue(i, col) {
    switch (col) {
      case 'producto':
        return this.rows[i].Producto.Producto;
      case 'cosecha':
        return this.rows[i].Cosecha.Cosecha;
      case 'saldo':
        return this.tnsPipe.transform(this.rows[i].Disponible);
      case 'comprometidas':
        return this.tnsPipe.transform(this.rows[i].Comprometidas);
      case 'oportunidades':
        return this.tnsPipe.transform(this.rows[i].Oportunidades);
      default:
        return '';
    }
  }

  displayToggle() {
    this.displayGrid = !this.displayGrid;
  }

  public searchSaldo(filter) {
    this.displayLoadCircle = true;
    const finalFilter = {
      AcopioId: filter.acopio,
      ClienteId: filter.cliente
    };
    this.cuentasService.getClienteSaldo(finalFilter)
      .subscribe(res => {
        this.rows = res;
        this.displayLoadCircle = false;
        this.noResultsMessage = 'No se encontraron valores';
      }, err => {
        this.displayLoadCircle = false;
        this.noResultsMessage = 'Hubo un problema al procesar la solicitud. Intente nuevamente';
      });
  }

  public clearSaldo() {
    this.rows = [];
    this.noResultsMessage = this.isNewNegocio ? 'Debe completar los campos "Cliente" y "Acopio"' : 'Por favor, seleccione un acopio';
  }

  getTooltip(col) {
    switch (col) {
      case 'saldo':
        return 'Dato provisto por Sistema de Acopio';
      case 'comprometidas':
        return 'Negocios No Finalizados';
      case 'oportunidades':
        return 'Negocios Activos';
      default:
        return '';
    }
  }

  getTooltipSaldo(col, i) {
    if (col === 'saldo') {
      return `Tns Totales Pendientes:  ${this.tnsPipe.transform(this.rows[i].TNTotalesPendientes)} \n
              Tns Certificadas:  ${this.tnsPipe.transform(this.rows[i].TNCertificados)} \n
              Tns Sin Certificar:  ${this.tnsPipe.transform(this.rows[i].TNSinCertificar)}`;
    }
    return '';
  }

  public noValuesToLoad() {
    this.noResultsMessage = 'No se obtuvieron acopios para solicitar saldos';
  }

  isNumberColumn(col) {
    return col === 'saldo' || col === 'oportunidades' || col === 'comprometidas';
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/cliente-saldo-list/cliente-saldo-list.component.ts